import { render, staticRenderFns } from "./BestReviewer.vue?vue&type=template&id=a9fc60ae&scoped=true&"
import script from "./BestReviewer.vue?vue&type=script&lang=js&"
export * from "./BestReviewer.vue?vue&type=script&lang=js&"
import style0 from "./BestReviewer.vue?vue&type=style&index=0&id=a9fc60ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc60ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VIcon,VSubheader})
